module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-84.9895167.woff2";